var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "48a50d1304c2503cddc0c8d3fced80ac3c7eb1e6"
};